export default {
  computed: {
    user() {
      const user = this.$store.getters['auth/user']
      return {
        id: user.id,
        name: `${user.first_name} ${user.last_name}`,
        email: user.email,
        image: user.image,
      }
    },
    getCourseDetails(){
        return this.$store.getters['courses/getAll'][this.$route.params.course_id]
    },
    getFirstGroup() {
        return this.getCourseDetails.groups[0].group
    },
    isTeacher(){
        return this.hasRole('teacher')
    },
    isStudent(){
        return this.hasRole('student')
    },
    hasManyGroups(){
        return this.getCourseDetails.groups.length > 1
    }
  },
  methods: {
    hasRole(role) {
      return this.$store.getters['auth/hasRole'](role)
    },
    viewProfile(id){
      this.$router.push({ name: 'profile', params: { user_id: id } })
    }
  }
}
